"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForceUpdate = exports.useStateRef = exports.useHasScrollbar = exports.useMeasure = void 0;
var react_1 = require("react");
function useMeasure() {
    var observer = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(null), elementRef = _a[0], setElementRef = _a[1];
    var _b = (0, react_1.useState)({
        x: undefined,
        y: undefined,
        height: undefined,
        width: undefined,
        top: undefined,
        bottom: undefined,
        left: undefined,
        right: undefined,
    }), contentRect = _b[0], setContentRect = _b[1];
    var ref = (0, react_1.useCallback)(function (node) {
        setElementRef(node);
    }, []);
    (0, react_1.useEffect)(function () {
        if (elementRef) {
            observer.current = new ResizeObserver(function (entries) {
                entries.forEach(function (entry) {
                    setContentRect(entry.contentRect.toJSON());
                });
            });
            observer.current.observe(elementRef);
        }
        return function () {
            var _a;
            (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
            observer.current = null;
        };
    }, [elementRef]);
    return { ref: ref, contentRect: contentRect };
}
exports.useMeasure = useMeasure;
function useHasScrollbar() {
    var observer = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(null), elementRef = _a[0], setElementRef = _a[1];
    var _b = (0, react_1.useState)({ horizontal: undefined, vertical: undefined }), hasScrollbar = _b[0], setHasScrollbar = _b[1];
    var ref = (0, react_1.useCallback)(function (node) {
        setElementRef(node);
    }, []);
    (0, react_1.useEffect)(function () {
        if (elementRef) {
            observer.current = new ResizeObserver(function (entries) {
                entries.forEach(function (entry) {
                    setHasScrollbar({
                        horizontal: entry.target.scrollWidth > entry.target.clientWidth,
                        vertical: entry.target.scrollHeight > entry.target.clientHeight,
                    });
                });
            });
            observer.current.observe(elementRef);
        }
        return function () {
            var _a;
            (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
            observer.current = null;
        };
    }, [elementRef]);
    return { ref: ref, hasScrollbar: hasScrollbar };
}
exports.useHasScrollbar = useHasScrollbar;
function useStateRef() {
    var _a = (0, react_1.useState)(null), el = _a[0], setEl = _a[1];
    var registerEl = (0, react_1.useCallback)(setEl, []);
    return { el: el, registerEl: registerEl };
}
exports.useStateRef = useStateRef;
function useForceUpdate() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _a = (0, react_1.useState)(new Date().getTime()), time = _a[0], setTime = _a[1];
    function forceUpdate() {
        setTime(new Date().getTime());
    }
    return forceUpdate;
}
exports.useForceUpdate = useForceUpdate;
